export const messages = {
  en: {
    auditUser: {
      title: 'Audit User Management',
      queryConditions: 'Query Conditions',
      auditId: 'Audit ID',
      auditor: 'Auditor',
      auditLink: 'Audit Link',
      query: 'Query',
      auditUserInfo: 'Audit User Information',
      add: 'Add',
      userId: 'User ID',
      userName: 'User Name',
      auditLinkName: 'Audit Link',
      processObject: 'Process Object',
      operation: 'Operation',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      confirmTitle: 'Please Confirm Your Operation',
      confirmContent: 'Are you sure to delete this auditor?',
      cancel: 'Cancel',
      departmentHead: 'Department Head',
      financeHead: 'Finance Head',
      purchaser: 'Purchaser'
    }
  },
  zh: {
    auditUser: {
      title: '审核人员管理',
      queryConditions: '查询条件',
      auditId: '审核ID',
      auditor: '审核人员',
      auditLink: '审核环节',
      query: '查询',
      auditUserInfo: '审核人员信息',
      add: '添加',
      userId: '用户ID',
      userName: '用户名称',
      auditLinkName: '审核环节',
      processObject: '流程对象',
      operation: '操作',
      delete: '删除',
      confirmDelete: '确认删除',
      confirmTitle: '请确认您的操作',
      confirmContent: '确定删除该审核人员吗？',
      cancel: '点错了',
      departmentHead: '部门主管',
      financeHead: '财务主管',
      purchaser: '采购人员'
    }
  }
}